<script setup lang="ts">
interface Props {
  products?: any[]
  showPrice?: boolean
}

const { products = [], showPrice = true } = defineProps<Props>()
const emits = defineEmits(['clickProduct', 'addCart'])
const attrs = useAttrs()
const { locale } = useI18n()
const { priceFiled: _priceFiled } = useAuthStore()
const localPath = useLocalePath()
const list = computed(() => {
  if (!products) {
    return [
      {
        id: 1,
        name: '提拉米蘇',
        price: 58.00,
        img: 'https://fastly.jsdelivr.net/npm/@vant/assets/apple-1.jpeg',
      },
      {
        id: 2,
        name: '提拉米蘇',
        price: 15.00,
        img: 'https://fastly.jsdelivr.net/npm/@vant/assets/apple-1.jpeg',
      },
      {
        id: 3,
        name: '提拉米蘇',
        price: 58.00,
        img: 'https://fastly.jsdelivr.net/npm/@vant/assets/apple-1.jpeg',
      },
      {
        id: 4,
        name: '提拉米蘇',
        price: 15.00,
        img: 'https://fastly.jsdelivr.net/npm/@vant/assets/apple-1.jpeg',
      },
    ]
  }

  return products.map((item) => {
    let price = item[_priceFiled]

    if (price) {
      price = Number(price).toFixed(2)
    }

    return {
      ...item,
      price,
      name: locale.value === 'en' ? item.descript : item.cdescript,
      img: item.path1 || item.image01,
    }
  })
})

// 点击商品图片
function productDetail(id: number) {
  // 如果有 clickProduct 事件，则调用 没有就跳转
  if (attrs.clickProduct) {
    emits('clickProduct', id)
  }
  else {
    navigateTo(localPath(`/product/${id}`))
  }
}

// 点击购物车图标
function joinCart(item: any) {
  emits('addCart', item)
}
</script>

<template>
  <div
    v-for="item in list"
    :key="item.id"
    class="product-item"
  >
    <van-image
      :src="item.img"
      :alt="item.name"
      @click="productDetail(item.scode)"
    />
    <div
      mt-1
      font-size-14px
    >
      {{ item.name }}
    </div>
    <div
      v-if="showPrice"
      flex
      justify-between
      class="price"
    >
      <div
        flex
        items-baseline
      >
        <div font-size-14px>
          HK$
        </div>
        <div class="font-size-16px font-bold">
          {{ item.price }}
        </div>
      </div>
      <svgo-shopcar
        filled
        class="text-xl"
        @click="joinCart(item)"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.product-item {
  img {
    border-radius: 10px;
  }
  .price {
    img {
      width: 1.375rem;
      height: 1.375rem;
    }
  }
}
</style>
